import React, { useEffect, useState } from 'react'
import {MoneyCollectOutlined, BookOutlined} from '@ant-design/icons';
import { Alert, Row, Col, Button, message } from 'antd';
import PageHeading from '../../components/PageHeading';
import CountCard from '../../components/dashboard/CountCard';
import axiosInstance from '../../utils/axios';


const JunkData = () => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
		setLoading(true);
		try {
			const response = await axiosInstance.get("booking/cleanup-bookings");
      const data = response.data ? response.data.count : count;
			setCount(data);
		} catch (error) {
			message.error("Failed to fetch count");
		} finally {
			setLoading(false);
		}
	};

  const clearAll = async () => {
    setLoading(true);
		try {
			await axiosInstance.post("booking/cleanup-bookings");
      setCount(0);
		} catch (error) {
			message.error("Failed to fetch count");
		} finally {
			setLoading(false);
		}
  }

  return (
    <div className='dashboard'>
		  <PageHeading name="Unpaid Bookings" icon={<MoneyCollectOutlined/>} />
      <Alert
        message="Unpaid & Expired Bookings"
        description="This section shows all bookings that were not completed due to unpaid transactions or expired time windows. Removing them will help free up database space and keep booking records clean."
        type="info"
        showIcon
      />
      <br/>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={12} xl={6}>
          {loading ? <>Loading...</> : <CountCard title="Unpaid" icon={<BookOutlined/>} count={count}/>}
        </Col>
      </Row>
      <br/>
      <Button color='danger' variant='solid' onClick={clearAll}>Clear All</Button>
    </div>
  )
}

export default JunkData
